import { Component } from '@angular/core';
import {euCompLeagueLinks} from "../../settings";

@Component({
  selector: 'app-league-centered',
  standalone: true,
  imports: [],
  templateUrl: './league-centered.component.html',
  styleUrl: './league-centered.component.scss'
})
export class LeagueCenteredComponent {

  protected readonly euCompLeagueLinks = euCompLeagueLinks;
}
